import { FC, ReactNode } from 'react'
import './LandingFeature.scss'

interface Props {
  icon: ReactNode
  title: ReactNode
  description: ReactNode
}

export const LandingFeature: FC<Props> = ({ icon, title, description }) => {
  return (
    <li className="LandingFeature">
      <div className="icon">{icon}</div>
      <h5 className="title">{title}</h5>
      <div className="description">{description}</div>
    </li>
  )
}
